<template>
  <div>
    <v-row>
      <v-col cols="12" lg="4" sm="6">
        <v-select dense outlined hide-details :items="reports" v-model="activeReport" @change="resetData" item-text="text" item-value="value"></v-select>
      </v-col>
      <v-col cols="2" lg="2" sm="4">
        <v-btn fab small dense color="green" dark :loading="excelLoading" v-if="viewHasData && activeReport !== 4" @click="exportAsExcel">
          <v-icon>mdi-file-excel</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" lg="3">
        <v-card>
          <v-card-text>
            <v-form ref="validateForm" autocomplete="off">
              <template v-if="activeReport === 1">
                <v-autocomplete outlined dense hide-details autocomplete="off" name="warehouse"
                  :label="$t('message.order.customer')" v-model="filterObj.customerid" clearable
                  :items="allCustomers" item-text="name" item-value="id" :item-disabled="isCustomerDisabled">
                  <template v-slot:item="{ item }">
                    <span :style="{ color: item.isactive ? 'inherit' : '#ec1b1b' }">
                      {{ item.name }}
                    </span>
                  </template>
                </v-autocomplete>
                <v-autocomplete outlined dense hide-details autocomplete="off" class="mt-4" name="customer_group"
                  :label="$t('message.customer.customerGroup')" v-model="filterObj.customergroupid" clearable
                  :items="listOfCustomerPriorities" item-text="name" item-value="id"></v-autocomplete>
                <v-autocomplete outlined dense hide-details autocomplete="off" class="mt-4" name="industry"
                  :label="$t('message.customer.industry')" v-model="filterObj.industry" clearable
                  :items="listofCustomerIndustries" item-text="name" item-value="id"></v-autocomplete>
                <v-menu :close-on-content-click="false" v-model="filterObj.startMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details dense class="mt-4" clearable :label="$t('message.order.startDate')" prepend-icon="event"
                    readonly v-on="on" v-model="filterObj.start" :rules="$_requiredValidation"
                    @click:clear="$nextTick(() => filterObj.startPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker :max="filterObj.endPicker" color="primary" v-model="filterObj.startPicker" @input="filterObj.startMenu = false"
                  :locale="$i18n.locale" first-day-of-week='1'></v-date-picker>
                </v-menu>
                <v-menu :close-on-content-click="false" v-model="filterObj.endMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details dense clearable :label="$t('message.order.endDate')" prepend-icon="event"
                    readonly v-on="on" v-model="filterObj.end" :rules="$_requiredValidation" class="mt-4"
                    @click:clear="$nextTick(() => filterObj.endPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker :min="filterObj.startPicker" color="primary" v-model="filterObj.endPicker" @input="filterObj.endMenu = false"
                  :locale="$i18n.locale" first-day-of-week='1'></v-date-picker>
                </v-menu>
                <!-- Group by year and month -->
                <!-- <label class="row mt-3 ml-0 font-weight-bold">{{ $t('message.turnoverReport.Groupby') }}</label> -->
                <!-- <v-layout class="pa-0 ma-0"> -->
                <v-checkbox class="ma-0 row mt-3" hide-details v-model="filterObj.groupbyyear" :label="$t('message.turnoverReport.GroupbyYear')"></v-checkbox>
                <v-checkbox class="ma-0 row" hide-details v-model="filterObj.groupbymonth" :label="$t('message.turnoverReport.GroupbyMonth')"></v-checkbox>
                <v-checkbox class="ma-0 row" hide-details v-model="filterObj.groupbycustomer" :label="$t('message.turnoverReport.groupbycustomer')"></v-checkbox>
                <!-- </v-layout> -->
                <!-- Ends -->
              </template>
              <template v-else-if="activeReport === 2 || activeReport === 3">
                <v-autocomplete v-if="activeReport === 2" outlined dense hide-details autocomplete="off" name="warehouse" multiple
                  :label="$t('message.layout.warehouse')" v-model="filterObj.warehouseids"
                  :items="listOfWarehouse" item-text="name" item-value="id"></v-autocomplete>
                <v-autocomplete outlined dense hide-details autocomplete="off" class="mt-4" name="product_group" multiple
                  :label="$t('message.customer.productGroup')" v-model="filterObj.productgroupids"
                  :items="listOfProductGroups" item-text="name" item-value="id"></v-autocomplete>
              </template>
              <template v-if="activeReport === 4">
                <v-autocomplete outlined dense hide-details autocomplete="off" name="warehouse"
                  :label="$t('message.deviations.category')" v-model="filterObj.categoryids" multiple clearable
                  :items="listOfDevationMeasureCategory" item-text="name" item-value="id"></v-autocomplete>
                <!-- <v-autocomplete outlined dense hide-details autocomplete="off" class="mt-4" name="customer_group"
                  :label="$t('message.deviations.location')" v-model="filterObj.locationids" multiple clearable
                  :items="listOfDevationLocation" item-text="name" item-value="id"></v-autocomplete> -->
                <v-autocomplete outlined dense hide-details autocomplete="off" class="mt-4" name="industry"
                  :label="$t('message.tickets.status')" v-model="filterObj.statusids" multiple clearable
                  :items="listOfDevationMeasureStatus" item-text="name" item-value="id"></v-autocomplete>
                <v-menu :close-on-content-click="false" v-model="filterObj.startMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details dense class="mt-4" clearable :label="$t('message.order.startDate')" prepend-icon="event"
                    readonly v-on="on" v-model="filterObj.start" :rules="$_requiredValidation"
                    @click:clear="$nextTick(() => filterObj.startPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker :max="filterObj.endPicker" color="primary" v-model="filterObj.startPicker" @input="filterObj.startMenu = false"
                  :locale="$i18n.locale" first-day-of-week='1'></v-date-picker>
                </v-menu>
                <v-menu :close-on-content-click="false" v-model="filterObj.endMenu" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field outlined hide-details dense clearable :label="$t('message.order.endDate')" prepend-icon="event"
                    readonly v-on="on" v-model="filterObj.end" :rules="$_requiredValidation" class="mt-4"
                    @click:clear="$nextTick(() => filterObj.endPicker = null)"></v-text-field>
                  </template>
                  <v-date-picker :min="filterObj.startPicker" color="primary" v-model="filterObj.endPicker" @input="filterObj.endMenu = false"
                  :locale="$i18n.locale" first-day-of-week='1'></v-date-picker>
                </v-menu>
                <!-- Group by year and month -->
                <v-radio-group v-model="filterObj.groupby" row>
                  <template v-slot:label>
                    <div>{{ $t('message.turnoverReport.Groupby') }}:</div>
                  </template>
                  <v-radio :label="$t('message.datestrings.month')" value="MONTH"></v-radio>
                  <v-radio :label="$t('message.datestrings.year')" value="YEAR"></v-radio>
                  <v-radio :label="$t('message.datestrings.quarter')" value="QUARTER"></v-radio>
                </v-radio-group>
                <!-- Ends -->
              </template>
              <v-divider class="mt-3"></v-divider>
            </v-form>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn dense color="green" :loading="loading" dark @click="getReportData">
              {{ $t('message.reports.runReport') }}
            </v-btn>
            <v-btn dense color="error" dark @click="resetData">
              {{ $t('message.user.clear') }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="6" lg="9">
        <template v-if="activeReport === 1 && viewHasData">
          <template v-if="groupByViewEnabled || groupByCustomer">
            <turnover-yearmonth-report :turnoverDataList="turnOverData" :year="show.year" :month="show.month" :key="reInitReport"
              :visibleMonthsInYears="visibleMonthsInYears"
              :groupByCustomer="groupByCustomer"
              :groupByViewEnabled="groupByViewEnabled"></turnover-yearmonth-report>
          </template>
          <turn-over v-else :turnoverObj="turnOverData"></turn-over>
        </template>
        <template v-else-if="activeReport === 2 && viewHasData">
          <inventory :inventoryObj="inventoryData"></inventory>
        </template>
        <template v-else-if="activeReport === 3 && viewHasData">
          <month-usage :monthsUsageRecords="usageRecords"></month-usage>
        </template>
        <template v-else-if="activeReport === 4 && viewHasData">
          <deviation-report :deviationReport="deviationReport" :groupby="deviationGroupBy"></deviation-report>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      reports: [{
        text: this.$t('message.reports.turnover'),
        value: 1
      }, {
        text: this.$t('message.reports.inventoryReport'),
        value: 2
      }, {
        text: this.$t('message.reports.monthUsage'),
        value: 3
      }, {
        text: this.$t('message.deviations.deviationReport'),
        value: 4
      }],
      activeReport: 1,
      filterObj: {
        start: moment().startOf('year').format('DD.MM.YYYY'),
        startPicker: moment().startOf('year').format('YYYY-MM-DD'),
        end: moment().format('DD.MM.YYYY'),
        endPicker: moment().format('YYYY-MM-DD'),
        warehouseids: [],
        productgroupids: [],
        groupbyyear: false,
        groupbymonth: false
      },
      loading: false,
      excelLoading: false,
      viewHasData: false,
      turnOverData: {},
      allCustomers: [],
      inventoryData: {},
      usageRecords: [],
      groupByViewEnabled: false,
      groupByCustomer: false,
      show: {
        year: false,
        month: false
      },
      reInitReport: 0,
      visibleMonthsInYears: {},
      deviationReport: [],
      deviationGroupBy: ''
    }
  },
  computed: {
    ...mapState(['listOfWarehouse', 'listOfProductGroups', 'listOfCustomerPriorities', 'listofCustomerIndustries', 'listOfDevationMeasureStatus', 'listOfDevationMeasureCategory'])
  },
  components: {
    'turn-over': () => import('@/components/Reports/Turnover.vue'),
    'inventory': () => import('@/components/Reports/Inventory.vue'),
    'month-usage': () => import('@/components/Reports/MonthsUsage.vue'),
    'turnover-yearmonth-report': () => import('@/components/Reports/TurnOverYearMonthViewReport.vue'),
    'deviation-report': () => import('@/components/Reports/DeviationReport.vue')
  },
  watch: {
    'filterObj.startPicker' (val) {
      if (val) {
        this.changeDate(val, 'start')
      }
    },
    'filterObj.endPicker' (val) {
      if (val) {
        this.changeDate(val, 'end')
      }
    }
  },
  mounted () {
    this.$store.dispatch('getWarehouse')
    this.$store.dispatch('getProductGroups')
    this.$store.dispatch('getAllCustomersIncludingInactive')
      .then((customers) => {
        this.allCustomers = customers
      })
    this.$store.dispatch('getCustomerPriority')
    this.$store.dispatch('getCustomerIndustry')
    this.$store.dispatch('getDeviationMeasureStatus')
    this.$store.dispatch('getDeviationMeasureCategory')
    // this.$store.dispatch('getDeviationLocation')
  },
  methods: {
    isCustomerDisabled (item) {
      return !item.isactive
    },
    getReportData () {
      if (this.$refs.validateForm.validate()) {
        this.loading = true
        if (this.activeReport === 1) {
          this.getTurnoverRecords()
        } else if (this.activeReport === 2) {
          this.getInventoryRecords()
        } else if (this.activeReport === 3) {
          this.getMonthsUsageRecords()
        } else if (this.activeReport === 4) {
          this.getDeviationRecords()
        }
      }
    },
    exportAsExcel () {
      this.excelLoading = true
      if (this.activeReport === 1) {
        this.generateExcelForTurnover()
      } else if (this.activeReport === 2) {
        this.generateExcelForInventory()
      } else if (this.activeReport === 3) {
        this.generateExcelForMonthUsage()
      }
    },
    resetData () {
      this.filterObj = {
        start: moment().startOf('year').format('DD.MM.YYYY'),
        startPicker: moment().startOf('year').format('YYYY-MM-DD'),
        end: moment().format('DD.MM.YYYY'),
        endPicker: moment().format('YYYY-MM-DD'),
        warehouseids: [],
        productgroupids: [],
        customerid: 0,
        groupby: 'MONTH',
        customergroupid: 0,
        industry: 0
      }
      this.resetAllRecords()
    },
    resetAllRecords () {
      this.viewHasData = false
      this.turnOverData = {}
      this.inventoryData = {}
    },
    getTurnoverRecords () {
      const { customerid, customergroupid, industry, start, end, groupbyyear, groupbymonth } = this.filterObj
      let model = {
        customerid: customerid || 0,
        customergroupid: customergroupid || 0,
        industry: industry || 0,
        start: this.$formatter.formatDate(start, 'DD.MM.YYYY', 'YYYY-MM-DDT00:00:00'),
        end: this.$formatter.formatDate(end, 'DD.MM.YYYY', 'YYYY-MM-DDT23:59:59'),
        groupbyyear,
        groupbymonth
      }
      this.groupByViewEnabled = this.filterObj.groupbyyear || this.filterObj.groupbymonth
      this.groupByCustomer = this.filterObj.groupbycustomer
      if (this.filterObj.groupbymonth) {
        let start = this.$formatter.formatDate(this.filterObj.start, 'DD.MM.YYYY', 'YYYY-MM-01')
        let end = this.$formatter.formatDate(this.filterObj.end, 'DD.MM.YYYY', 'YYYY-MM-01')
        this.getBetweenMonths(start, end)
      }
      let url = '/invoices/get_turnover_data'
      if (this.groupByViewEnabled && this.groupByCustomer) url = '/invoices/get_turnover_data_per_customer_with_period'
      else if (this.groupByViewEnabled) url = '/invoices/get_turnover_data_with_grouping'
      else if (this.groupByCustomer) url = '/invoices/get_turnover_data_per_customer'
      this.turnOverData = this.groupByViewEnabled ? [] : {}
      this.$_executeApi('post', url, model)
        .then((response) => {
          if (this.groupByViewEnabled) {
            this.turnOverData = response.data
            if (this.filterObj.groupbymonth) this.turnOverData = this.turnOverData.map(obj => ({ ...obj, expanded: true }))
            if (this.turnOverData && this.turnOverData.length > 0) this.viewHasData = true
          } else if (this.groupByCustomer) {
            this.turnOverData = response.data
            if (this.turnOverData && this.turnOverData.length > 0) this.viewHasData = true
          } else {
            // is Object
            this.turnOverData = response.data
            if (this.turnOverData.invoicerecords && this.turnOverData.invoicerecords.length > 0) this.viewHasData = true
          }
          this.show.year = this.filterObj.groupbyyear
          this.show.month = this.filterObj.groupbymonth
          this.reInitReport++
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDeviationRecords () {
      const { statusids, locationids, categoryids, start, end, groupby } = this.filterObj
      let model = {
        categoryids: categoryids || [],
        statusids: statusids || [],
        locationids: locationids || [],
        fromdate: this.$formatter.formatDate(start, 'DD.MM.YYYY', 'YYYY-MM-DDT00:00:00'),
        tilldate: this.$formatter.formatDate(end, 'DD.MM.YYYY', 'YYYY-MM-DDT23:59:59'),
        groupby
      }
      this.loading = true
      this.deviationReport = []
      this.$_executeApi('post', 'deviations/get_deviation_report', model)
        .then((response) => {
          if (response.data) {
            this.deviationReport = response.data
            this.deviationGroupBy = model.groupby
            if (this.deviationReport && this.deviationReport.length > 0) this.viewHasData = true
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getBetweenMonths (start, end) {
      var startDate = moment(start)
      var endDate = moment(end)
      var result = {}
      while (startDate.isSameOrBefore(endDate)) {
        let year = +(startDate.year())
        let month = startDate.month() + 1
        if (result.hasOwnProperty(year)) {
          result[year].push(month)
        } else {
          result[year] = [month]
        }
        startDate.add(1, 'month')
      }
      this.visibleMonthsInYears = result
    },
    getInventoryRecords () {
      this.$_executeApi('post', '/stocks/get_inventory_report', this.filterObj)
        .then((response) => {
          this.inventoryData = response.data
          if (this.inventoryData.inventoryrecords && this.inventoryData.inventoryrecords.length > 0) this.viewHasData = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    getMonthsUsageRecords () {
      this.$_executeApi('post', '/stocks/get_product_usage_report', this.filterObj.productgroupids || [])
        .then((response) => {
          this.usageRecords = response.data
          if (this.usageRecords && this.usageRecords.length > 0) this.viewHasData = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    generateExcelForTurnover () {
      let model = {
        customerid: this.filterObj.customerid || 0,
        customergroupid: this.filterObj.customergroupid || 0,
        industry: this.filterObj.industry || 0,
        start: this.$formatter.formatDate(this.filterObj.start, 'DD.MM.YYYY', 'YYYY-MM-DDT00:00:00'),
        end: this.$formatter.formatDate(this.filterObj.end, 'DD.MM.YYYY', 'YYYY-MM-DDT23:59:59'),
        groupbyyear: this.filterObj.groupbyyear,
        groupbymonth: this.filterObj.groupbymonth,
        groupbycustomer: this.filterObj.groupbycustomer
      }
      this.$_executeApi('post', '/invoices/generate_excel_turnover', model)
        .then((response) => {
          var fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.excelLoading = false
        })
    },
    generateExcelForInventory () {
      this.$_executeApi('post', '/stocks/generate_excel_inventory', this.filterObj)
        .then((response) => {
          var fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.excelLoading = false
        })
    },
    generateExcelForMonthUsage () {
      this.$_executeApi('post', '/stocks/generate_excel_monthusage', this.filterObj.productgroupids || [])
        .then((response) => {
          var fileName = response.data
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
        .finally(() => {
          this.excelLoading = false
        })
    },
    changeDate (value, field) {
      this.filterObj[field] = this.$formatter.formatDate(value, 'YYYY-MM-DD', 'DD.MM.YYYY')
    },
    getmonthName (index) {
      let lang = this.$i18n.locale === 'en' ? 'en' : 'nb'
      let list = moment.localeData(lang).months()
      return list[index]
    }
  }
}
</script>
